export default "__VITE_ASSET__80b379b7__"